export const opportunityLabelContext = {
  very_high: {
    icon: 'chevron-up-double',
    bgClass: 'bg-proxify-success-50',
    iconClass: 'text-proxify-success-500',
    textClass: 'text-proxify-success-700',
  },
  high: {
    icon: 'chevron-up',
    bgClass: 'bg-proxify-success-50',
    iconClass: 'text-proxify-success-500',
    textClass: 'text-proxify-success-700',
  },
  medium: {
    icon: 'equal',
    bgClass: 'bg-[#fffaeb]',
    iconClass: 'text-[#b54708]',
    textClass: 'text-[#b54708]',
  },
  low: {
    icon: 'chevron-down',
    bgClass: 'bg-proxify-error-50',
    iconClass: 'text-proxify-error-500',
    textClass: 'text-proxify-error-700',
  },
  very_low: {
    icon: 'chevron-down-double',
    bgClass: 'bg-proxify-error-50',
    iconClass: 'text-proxify-error-500',
    textClass: 'text-proxify-error-700',
  },
  unclassified: {
    icon: 'info-circle',
    bgClass: 'bg-proxify-gray-100',
    iconClass: 'text-proxify-gray-500',
    textClass: 'text-proxify-gray-700',
  },
};
